export const lightTheme = {
  root: {
    fontSize: "0.75rem",
  },
};

export default {
  lightTheme,
};
